import { render, staticRenderFns } from "./CustomerProductForm.vue?vue&type=template&id=1581e8e8"
import script from "./CustomerProductForm.vue?vue&type=script&lang=js"
export * from "./CustomerProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports